import jwt from '@src/auth/jwt/useJwt'

export const createTicketApi = async ({ userId, formData }) => {
  try {
    const response = await jwt.post('tickets', formData, {
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 422) {
      const code = error?.response?.data?.code || 'image_rejected'
      const err = new Error(code)
      err.type = code
      throw err
    }
    if (status === 400) {
      const err = new Error('BAD_REQUEST')
      err.type = 'BAD_REQUEST'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const fetchUserTicketsApi = async ({ userId, cursor, limit = 20 }) => {
  const params = { limit }
  if (cursor) params.cursor = cursor
  try {
    const response = await jwt.get('user/tickets', {
      params,
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 400) {
      const err = new Error('BAD_REQUEST')
      err.type = 'BAD_REQUEST'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const fetchUserTicketDetailApi = async ({ userId, ticketId }) => {
  try {
    const response = await jwt.get(`user/tickets/${ticketId}`, {
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 404) {
      const err = new Error('NOT_FOUND')
      err.type = 'NOT_FOUND'
      throw err
    }
    if (status === 400) {
      const err = new Error('BAD_REQUEST')
      err.type = 'BAD_REQUEST'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const respondUserTicketApi = async ({ userId, ticketId, message }) => {
  try {
    const response = await jwt.post(
      `user/tickets/${ticketId}/respond`,
      { response: message },
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('OWNERSHIP_REQUIRED')
      err.type = 'OWNERSHIP_REQUIRED'
      throw err
    }
    if (status === 404) {
      const err = new Error('NOT_FOUND')
      err.type = 'NOT_FOUND'
      throw err
    }
    if (status === 409) {
      const err = new Error('TICKET_CLOSED')
      err.type = 'TICKET_CLOSED'
      throw err
    }
    if (status === 400) {
      const err = new Error('BAD_REQUEST')
      err.type = 'BAD_REQUEST'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const closeUserTicketApi = async ({ userId, ticketId }) => {
  try {
    const response = await jwt.post(
      `user/tickets/${ticketId}/close`,
      {},
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('OWNERSHIP_REQUIRED')
      err.type = 'OWNERSHIP_REQUIRED'
      throw err
    }
    if (status === 404) {
      const err = new Error('NOT_FOUND')
      err.type = 'NOT_FOUND'
      throw err
    }
    if (status === 409) {
      const err = new Error('TICKET_CLOSED')
      err.type = 'TICKET_CLOSED'
      throw err
    }
    if (status === 400) {
      const err = new Error('BAD_REQUEST')
      err.type = 'BAD_REQUEST'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const reopenUserTicketApi = async ({ userId, ticketId }) => {
  try {
    const response = await jwt.post(
      `user/tickets/${ticketId}/reopen`,
      {},
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('OWNERSHIP_REQUIRED')
      err.type = 'OWNERSHIP_REQUIRED'
      throw err
    }
    if (status === 404) {
      const err = new Error('NOT_FOUND')
      err.type = 'NOT_FOUND'
      throw err
    }
    if (status === 400) {
      const err = new Error('BAD_REQUEST')
      err.type = 'BAD_REQUEST'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}
